/** Billing metadata from the Store associated with the selected purchase. */
export interface SubscriptionStore {
  id: number
  period: number | null
  apple_id: string | null
  categoryName: string | null
}

export function parseSubscriptionStore(value: unknown, expectedId: number): SubscriptionStore {
  if (!Number.isSafeInteger(expectedId) || expectedId <= 0 || !value || typeof value !== 'object') {
    throw new Error('Invalid subscription store')
  }
  const store = value as Record<string, unknown>
  if (store.id !== expectedId ||
    !(store.period === null || (typeof store.period === 'number' && Number.isSafeInteger(store.period) && store.period >= 0)) ||
    !(store.apple_id === null || typeof store.apple_id === 'string')) {
    throw new Error('Invalid subscription store metadata')
  }
  const category = store.category as { name?: unknown } | null | undefined
  return {
    id: expectedId,
    period: store.period as number | null,
    apple_id: store.apple_id as string | null,
    categoryName: typeof category?.name === 'string' ? category.name : null,
  }
}
